<template>
    <b-container class="contentcontainer site-detail__backups">
      <b-row class="contentcontainer__head">
        <b-col>
          <h2>{{$t('site.updatesites')}}</h2>
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col>
          <div class="info">
            <div class="table-responsive-lg">
              <table class="table table--overview">
                <thead>
                <tr>
                  <th>
                    {{$t('site.updatename')}}
                  </th>
                  <th>
                    {{$t('site.last_check_timestamp')}}
                  </th>
                  <th class="text-center">
                    {{$t('site.enabled')}}
                  </th>
                </tr>
                </thead>

                <tbody>
                  <site-detail-updatesite-item
                    v-for="(updatesite, index) in siteDetail.data.updatesites"
                    :key="updatesite.id"
                    :class="(index % 2 === 0) ? 'odd' : 'even'"
                    v-bind="updatesite"
                  ></site-detail-updatesite-item>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

import SiteDetailUpdatesiteItem from './SiteDetailUpdatesiteItem'

export default {

  name: 'UpdatesiteSection',

  components: {

    SiteDetailUpdatesiteItem
  },

  props: {

    showFullListLink: {
      default: true
    },
    showBackLink: {
      default: false
    },
    limit: {
      default: 5
    },
    showPagination: {
      default: false
    }
  },

  computed: {
    ...mapState('site', [
      'siteDetail'
    ])
  },

  watch: {},

  methods: {

    ...mapMutations('site', [
      'showSiteDetailPageBackups'
    ]),

    ...mapActions('backup', [
      'backup'
    ]),

    close () {
      this.$emit('close-detail')
    }
  }
}
</script>
